import { Meta } from "@/shared/components";
import { BillingPayments } from "@/admin/features/billing";

export function BillingPaymentsPage() {
  return (
    <>
      <Meta title="Платежи по контрактам" />
      <BillingPayments />
    </>
  );
}
